import { formatDate } from "./formatDate";

export const createMRRecord = async (formData, resetForm) => {
  const conn_name = "crmwidgetconnection";

  console.log("Creating MR with formData:", formData); // Debug log

  // Map form fields to Zoho Creator fields
  const payload = {
    parameters: {
      data: {
        // Basic fields
        status: formData.status || "Planned",
        Status: formData.status || "Planned",
        Note_taker_for_this_Management_Review: formData.noteTaker || "",

        // Dates
        Date_of_this_Management_Review: formData.date
          ? formatDate(new Date(formData.date))
          : "",
        Date_of_previous_Management_Review: formData.previousDate
          ? formatDate(new Date(formData.previousDate))
          : "",

        // Agenda items section 1
        a1: formData.agendaItems?.a || "",
        b1: formData.agendaItems?.b || "",
        c1: formData.agendaItems?.c || "",

        // Agenda items section 2
        a2: formData.agendaItems?.businessPerformance || "",
        b2: formData.agendaItems?.internalAuditResults || "",
        c2: formData.agendaItems?.supplierPerformance || "",
        d2: formData.agendaItems?.resourceAdequacy || "",
        e2: formData.agendaItems?.maintenanceIssues || "",
        f2: formData.agendaItems?.customerFeedback || "",

        // Agenda items section 3-5
        a3: formData.agendaItems?.risks || "",
        a4: formData.agendaItems?.opportunities || "",
        a5: formData.agendaItems?.businessUpdates || "",

        // Recap items section 6
        a6: formData.agendaItems?.recapItemA || "",
        b6: formData.agendaItems?.recapItemB || "",
        c6: formData.agendaItems?.recapItemC || "",
      },
    },
    method: "POST",
    url: "https://www.zohoapis.com/creator/v2.1/data/sst1source/source-erp/form/Management_Review",
    param_type: 2,
  };

  try {
    console.log("Sending payload to Zoho:", payload); // Debug log
    const response = await ZOHO.CRM.CONNECTION.invoke(conn_name, payload);
    console.log("Management Review record created:", response);

    if (response && response.code === "SUCCESS") {
      console.log("Zoho create response data:", response.data); // Add this for debugging
      return response.data || response;
    } else {
      const errorMsg =
        response?.message ||
        "Unknown error occurred while creating Management Review.";
      console.error("API error response:", errorMsg);
      throw new Error(errorMsg);
    }
  } catch (error) {
    console.error("Error invoking Zoho connection for creating MR:", error);
    throw error;
  }
};
